const syncSectionBackground = (wrapper) => {
  if (!(wrapper instanceof HTMLElement)) return;

  const sectionWrapper = wrapper.closest('.shopify-section');
  const styles = getComputedStyle(wrapper);
  const marginProperties = {
    'margin-block-start': styles.getPropertyValue('--section-margin-block-start'),
    'margin-block-end': styles.getPropertyValue('--section-margin-block-end'),
    'margin-inline-start': styles.getPropertyValue('--section-margin-inline-start'),
    'margin-inline-end': styles.getPropertyValue('--section-margin-inline-end'),
  };

  if (sectionWrapper instanceof HTMLElement) {
    const isHeaderSection = sectionWrapper.closest('#header-group') !== null;

    if (isHeaderSection) {
      sectionWrapper.style.setProperty('margin-block-start', '0px');
      sectionWrapper.style.setProperty('margin-block-end', '0px');
      sectionWrapper.style.setProperty('margin-inline-start', marginProperties['margin-inline-start'] || '0px');
      sectionWrapper.style.setProperty('margin-inline-end', marginProperties['margin-inline-end'] || '0px');
      sectionWrapper.style.setProperty(
        'width',
        `calc(100% - ${marginProperties['margin-inline-start'] || '0px'} - ${marginProperties['margin-inline-end'] || '0px'})`
      );
      wrapper.style.setProperty('margin', '0px');
      wrapper.style.setProperty('transform', `translateY(${marginProperties['margin-block-start'] || '0px'})`);
    } else {
      Object.entries(marginProperties).forEach(([property, value]) => {
        sectionWrapper.style.setProperty(property, value || '0px');
      });
    }

    if (!isHeaderSection) wrapper.style.setProperty('margin', '0px');
    wrapper.style.setProperty('width', '100%');
  }

  const background = wrapper.previousElementSibling;
  if (!(background instanceof HTMLElement) || !background.classList.contains('section-background')) return;

  const properties = [
    'width',
    'margin-inline-start',
    'margin-inline-end',
    'margin-block-start',
    'margin-block-end',
    'border-radius',
  ];

  properties.forEach((property) => {
    background.style.setProperty(property, styles.getPropertyValue(property));
  });
}

const syncSectionBackgrounds = (root = document) => {
  if (root instanceof HTMLElement && root.matches('[style*="--section-border-radius"]')) {
    syncSectionBackground(root);
  }

  root.querySelectorAll('[style*="--section-border-radius"]').forEach(syncSectionBackground);
};

syncSectionBackgrounds();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) syncSectionBackgrounds(event.target);
});

document.addEventListener('shopify:section:reorder', () => syncSectionBackgrounds());
